import DocsLayout from '../components/DocsLayout';
import Introduction from './docs/v3/Introduction';
import WorldPicker from './docs/v3/WorldPicker';
import LevelEditor from './docs/v3/LevelEditor';
import PlayerEditor from './docs/v3/PlayerEditor';
import WorldEditor from './docs/v3/WorldEditor';
import Addons from './docs/v3/Addons';
import RealmsServers from './docs/v3/RealmsServers';
import Backups from './docs/v3/Backups';
import SavingChanges from './docs/v3/SavingChanges';
import Settings from './docs/v3/Settings';
import Console from './docs/v3/Console';
import Troubleshooting from './docs/v3/Troubleshooting';

const sections = [
  { id: 'introduction', title: 'Introduction', children: [
    { id: 'whats-new', title: 'What is new' },
    { id: 'getting-started', title: 'Getting started' },
    { id: 'safety', title: 'Keeping your world safe' },
    { id: 'requirements', title: 'System requirements' },
  ]},
  { id: 'world-picker', title: 'Choosing a world', children: [
    { id: 'picker-list', title: 'The world list' },
    { id: 'picker-detail', title: 'The details pane' },
    { id: 'picker-health', title: 'Worlds that will not open' },
    { id: 'picker-without-world', title: 'Without a world open' },
  ]},
  { id: 'level-editor', title: 'Level Editor', children: [
    { id: 'world-info', title: 'World Info' },
    { id: 'gameplay', title: 'Gameplay' },
    { id: 'gamerules', title: 'Gamerules' },
    { id: 'experiments', title: 'Experiments' },
    { id: 'abilities', title: 'Abilities' },
    { id: 'flat-world', title: 'Flat World' },
    { id: 'level-advanced', title: 'Advanced' },
  ]},
  { id: 'player-editor', title: 'Player Editor', children: [
    { id: 'player-choose', title: 'Choosing a player' },
    { id: 'player-general', title: 'General' },
    { id: 'player-inventory', title: 'Inventory' },
    { id: 'player-custom-item', title: 'Custom Item' },
    { id: 'player-effects', title: 'Effects' },
    { id: 'player-tamed', title: 'Tamed Pets' },
    { id: 'player-properties', title: 'Properties and tags' },
    { id: 'player-advanced', title: 'Advanced' },
    { id: 'player-search', title: 'Searching across players' },
    { id: 'player-transfer', title: 'Player transfer' },
  ]},
  { id: 'world-editor', title: 'World Editor', children: [
    { id: 'world-map', title: 'World Map and pruning' },
    { id: 'chunk-inspector', title: 'Chunk Inspector' },
    { id: 'block-search', title: 'Block Search' },
    { id: 'world-entities', title: 'Entities' },
    { id: 'block-entities', title: 'Block Entities' },
    { id: 'world-properties', title: 'Properties & Scoreboards' },
    { id: 'villager-trades', title: 'Villager Trades' },
    { id: 'villages', title: 'Villages' },
    { id: 'world-tools', title: 'World Tools' },
    { id: 'world-maps', title: 'Maps' },
    { id: 'world-structures', title: 'Structures' },
    { id: 'tick-data', title: 'Tick Data' },
  ]},
  { id: 'addons', title: 'Add-ons', children: [
    { id: 'world-addons', title: 'World Add-ons' },
    { id: 'minecraft-addons', title: 'Minecraft Add-ons' },
  ]},
  { id: 'realms-servers', title: 'Realms & Servers', children: [
    { id: 'realms-sign-in', title: 'Signing in' },
    { id: 'realms-list', title: 'Your Realms' },
    { id: 'realms-edit', title: 'Editing a Realm world' },
    { id: 'realms-manage', title: 'Managing a Realm' },
    { id: 'servers', title: 'Dedicated servers' },
  ]},
  { id: 'backups', title: 'Backups', children: [
    { id: 'backups-automatic', title: 'Automatic backups' },
    { id: 'backups-section', title: 'The Backups screen' },
    { id: 'backups-remote', title: 'Servers and Realms' },
    { id: 'backups-restore', title: 'Restoring' },
    { id: 'backups-retention', title: 'Retention' },
    { id: 'backups-v2', title: 'Moving 2.x backups out' },
    { id: 'restore-points', title: 'Restore points' },
  ]},
  { id: 'saving', title: 'Saving changes', children: [
    { id: 'saving-staging', title: 'The action bar' },
    { id: 'saving-review', title: 'Reviewing first' },
    { id: 'saving-what-happens', title: 'What a save does' },
    { id: 'saving-after', title: 'After saving' },
  ]},
  { id: 'settings', title: 'Settings', children: [
    { id: 'settings-language', title: 'Language' },
    { id: 'settings-backups', title: 'Backups' },
    { id: 'settings-updates', title: 'Updates' },
    { id: 'settings-network', title: 'Network' },
    { id: 'settings-storage', title: 'Storage locations' },
    { id: 'settings-theme', title: 'Light and dark' },
  ]},
  { id: 'console', title: 'Console' },
  { id: 'troubleshooting', title: 'Troubleshooting & FAQ', children: [
    { id: 'faq', title: 'Frequently asked' },
    { id: 'common-issues', title: 'Common issues' },
  ]},
];

export default function Docs() {
  return (
    <DocsLayout
      version="3"
      sections={sections}
      intro="Everything Bedrock Toolchest 3.1 does, screen by screen. Pick a topic from the sidebar, or read straight through."
    >
      <Introduction />
      <WorldPicker />
      <LevelEditor />
      <PlayerEditor />
      <WorldEditor />
      <Addons />
      <RealmsServers />
      <Backups />
      <SavingChanges />
      <Settings />
      <Console />
      <Troubleshooting />
    </DocsLayout>
  );
}
